import React, { useEffect, useState } from "react";
import Webcam from "react-webcam";
import SpeechRecognition, { useSpeechRecognition } from "react-speech-recognition";
import Modal from '../modals/Modal'; 
const RecordingScreen = ({
  initialAnswer,
  recording,
  webcamRef,
  cameraType,
  handleNext,
  handleRecord,
  styles,
}) => {
  const [recognizedIndex, setRecognizedIndex] = useState(0);
  const { transcript, resetTranscript } = useSpeechRecognition();
  const [showModal, setShowModal] = useState(false); 

  const textToRead = initialAnswer === "no"
    ? "I username do not have my spouse, parents, siblings, and children working as advisors with ICICI Pru or any other insurance companies."
          : "I username, have either my spouse, parents, siblings, and children working as an advisor with ICICI Pru or any other insurance companies and I have declared the details in the conflict of interest link."
  
  const normalizeText = (text) => {
    return text
      .replace(/[.,/#!$%^&*;:{}=\-_`~()]/g, "") 
      .replace(/\s{2,}/g, " ") 
      .trim()
      .toLowerCase(); 
  };

  const normalizedTextWords = normalizeText(textToRead).split(" ");

  useEffect(() => {
    if (recording) {
      SpeechRecognition.startListening({ continuous: true, language: "en-US" });
    } else {
      SpeechRecognition.stopListening();
    }

    return () => {
      SpeechRecognition.stopListening();
    };
  }, [recording]);

  useEffect(() => {
    const recognizedWords = normalizeText(transcript).split(" ");
    let newIndex = recognizedIndex;

    while (
      newIndex < normalizedTextWords.length &&
      recognizedWords.includes(normalizedTextWords[newIndex])
    ) {
      newIndex += 1;
    }

    setRecognizedIndex(newIndex);
  }, [transcript]);

  const getHighlightedText = (text, highlights) => {
    const words = text.split(/\s+/);
    let wordIndex = 0;

    return (
      <span>
        {words.map((word, i) => {
          const normalizedWord = normalizeText(word);

          const highlight =
            wordIndex < highlights && normalizedWord === normalizedTextWords[wordIndex]
              ? "red"
              : "black";

          if (normalizedWord === normalizedTextWords[wordIndex]) {
            wordIndex += 1;
          }

          return (
            <span
              key={i}
              style={{
                color: highlight,
              }}
            >
              {word}{" "}
            </span>
          );
        })}
      </span>
    );
  };

  const handleNextClick = () => {
    if (recognizedIndex >= normalizedTextWords.length) {
      handleNext();
    } else {
      setShowModal(true); 
      resetTranscript();
      setRecognizedIndex(0);
    }
  };
  const handleModalClose = () => {
    setShowModal(false); 
  };

  return (
    <div style={styles.container}>
      <div style={styles.centered}>
        <Webcam
          audio
          ref={webcamRef}
          screenshotFormat="image/jpeg"
          videoConstraints={{ facingMode: cameraType }}
        />
      </div>
      <p style={styles.text}>{getHighlightedText(textToRead, recognizedIndex)}</p>
      <div style={styles.buttonContainer}>
        {recording ? (
          <div>
            <button style={styles.recordButton} onClick={handleNextClick}>
              Next
            </button>
          </div>
        ) : (
          <div>
            <button style={styles.recordButton} onClick={handleRecord}>
              Start Recording
            </button>
          </div>
        )}
      </div>
      <Modal
        isOpen={showModal}
        onClose={handleModalClose}
        message="Please read the entire text carefully and try again."
      />
    </div>
  );
};

export default RecordingScreen;
